import { render, staticRenderFns } from "./QuickReply.vue?vue&type=template&id=f3b8bec4"
import script from "./QuickReply.vue?vue&type=script&lang=js"
export * from "./QuickReply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports